module.exports = __webpack_public_path__ + "media/images/flags/32/Nepal-9c2ef1d21a7089c6aaf72e8503589a97.png";